import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "../../components/CircularProgress";
import { useBattleContext } from "../context";
import { BattleURL, IsBeta } from "../../utils/Network";
import BattleResultDialog from "../components/battle-result/battle-result-dialog";
import { useSearchParams } from "react-router-dom";
import { setPlayable } from "../../redux/music/action";

type Props = {};

const LiveBattleIframe = (props: Props) => {
  const userToken = useSelector((state: any) => state.userToken);
  const { gameInfo } = useBattleContext();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const battleId = searchParams.get("battleId");
  const replayId = searchParams.get("replayId");
  const DestParams = useMemo(() => {
    if (battleId) {
      return `watch=${battleId}`;
    }
    if (replayId) {
      return `replay=${replayId}`;
    }
    return "";
  }, [battleId, replayId]);

  // useEffect(() => {
  //   if(userToken){
  //     setTimeout(() => {
  //       window.location.href = `https://launch.playcanvas.com/2056653?clientReady=true&rootUrl=https://devbattle.chainoflegends.com&token=${userToken}`;
  //     }, 5000);
  //   }
  // },[userToken])
  // return (
  //   <div className="d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 left-0">
  //     <CircularProgress />
  //   </div>
  // );
  const iframeURL = gameInfo?.arenaGameUrl;

  const destLink = `${localStorage.getItem("iframeURL") || iframeURL}?${
    DestParams ? DestParams : "clientReady=true"
  }&rootUrl=${BattleURL}&token=${userToken}`;

  useEffect(() => {
    dispatch(setPlayable(false));
  }, []);

  return (
    <>
      <div
        style={{ backgroundColor: "rgba(0,0,0,.5)" }}
        className="d-flex  justify-content-center align-items-center w-100 h-100 position-absolute top-0 left-0"
      >
        <CircularProgress />
      </div>
      {iframeURL && (
        <iframe
          src={destLink}
          width="100%"
          height="100%"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 10,
          }}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
      <BattleResultDialog />
    </>
  );
};

export default LiveBattleIframe;
